// @ts-strict-ignore
import Link from 'next/link'
import React, { useState } from 'react'

import { MarkdownForm } from '@/screens/catalog-markdown/ui/MarkdownForm/MarkdownForm'
import { MarkdownItem, MarkdownProduct } from '@/screens/catalog-markdown/ui/MarkdownItem/MarkdownItem'
import discount from '@/screens/Discount/page/ui/assets/discount.svg'
import service from '@/screens/Discount/page/ui/assets/service.svg'
import wallet from '@/screens/Discount/page/ui/assets/wallet.png'
import { useGetMarkdownOfProductQuery } from '@/screens/Product'

import { Modal } from '@/shared/ui'
import { ItemType, TitleWithTriggers } from '@/shared/ui/TitleWithTriggers/TitleWithTriggers'

import styles from './styles.module.scss'

type DiscountTabProps = {
	KOD: string
}

const items: ItemType[] = [
	{
		type: 'icon',
		iconId: 'market',
		title: 'Витринные ',
		subtitle: 'образцы'
	},
	{
		type: 'icon',
		iconId: service,
		title: 'Гарантия',
		subtitle: '90 дней'
	},
	{
		type: 'icon',
		iconId: discount,
		title: 'Доступна',
		subtitle: 'рассрочка'
	},
	{
		type: 'image',
		src: wallet as unknown as string,
		alt: 'Яндекс сплит',
		title: 'Яндекс',
		subtitle: 'сплит'
	}
]

export const MarkdownTab = ({ KOD }: DiscountTabProps): JSX.Element => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [modalData, setModalData] = useState<MarkdownProduct>(null)
	const { data } = useGetMarkdownOfProductQuery(KOD)
	const openModal = (product: MarkdownProduct) => {
		setModalData(product)
		setIsModalOpen(true)
	}

	const closeModal = () => {
		setIsModalOpen(false)
		setModalData(null)
	}

	const sectionLink = data?.data?.SECTION_LINK || ''
	const productData = data?.data.PRODUCTS || null

	return (
		<section className={styles.root}>
			<div className={styles.triggers}>
				<TitleWithTriggers nonTitle title="Уценённые товары" items={items} />
			</div>

			<div className={styles.list}>
				{productData && <MarkdownItem isOpen onOpenModal={openModal} data={productData} />}
			</div>
			{!!sectionLink && (
				<Link prefetch={false} href={sectionLink.replace(`/catalog`, ``)} target="_blank" className={styles.link}>
					Все товары раздела
				</Link>
			)}

			{modalData && (
				<Modal isOpen={isModalOpen} onClose={closeModal}>
					<MarkdownForm
						KOD={modalData.KOD}
						STOCK_CODE={modalData.STOCK_CODE}
						TITLE={modalData.TITLE}
						PRICE={modalData.PRICE}
						PART_NUMBER={modalData.PART_NUMBER}
						STOCK_NAME={modalData.STOCK_NAME}
						OLD_PRICE={modalData.OLD_PRICE}
						IMAGES={modalData.IMAGES}
					/>
				</Modal>
			)}
		</section>
	)
}
